module.exports = __webpack_public_path__ + "img/slide32.2566e843.png";